import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from "react-query";

const fetchCorrDistGraph = async (graphVar) => {
    const { plateId, wellId } = graphVar;
    const headerConfig = setHeaders();
    const { data: urlWrapper } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/ddpcr/graph/corr_dist/${plateId}/${wellId}`,
        { headers: headerConfig }
    );
    const { data: graphData } = await axios.get(urlWrapper.signedUrl);
    return graphData;
};

export default function useFetchCorrDistGraphData(graphVar) {
    return useQuery(["corrDistGraph", graphVar], () => fetchCorrDistGraph(graphVar), {
        enabled: !!(graphVar?.plateId && graphVar?.wellId),
        onError: (error) => console.log({ error }),
        refetchOnWindowFocus: false,
    });
}
